import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import Rpp from "./Rpp";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <React.StrictMode>
      <Rpp />
    </React.StrictMode>
  </BrowserRouter>
);

reportWebVitals();
// 👉 Registro del Service Worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("✅ Service Worker registrado:", registration);
      })
      .catch((error) => {
        console.log("❌ Error al registrar el Service Worker:", error);
      });
  });
}

